<template>
<div>
  <v-layout mb-2 row justify-end>
    <div>
      <a
        @click.prevent.stop="showTerms"
      >
        {{ $t('extracurriculares.pay_reserve.terms_conditions') }}
      </a>
    </div>
  </v-layout>
  <v-container v-if="loading_page" grid-list-xl text-xs-center>
      <v-layout>
          <v-flex>
              <v-progress-circular
                  :size="50"
                  color="primary"
                  indeterminate
              ></v-progress-circular>
          </v-flex>
      </v-layout>
  </v-container>
  <v-card v-if="!coursesAvailable && !loading_page && !showPortfolio">
    <v-layout row wrap justify-center>
      <v-flex xs12 sm6>
        <v-alert type="info" :value="true">
          {{ $t('extracurriculares.register.available_courses.no_inscriptions') }}
        </v-alert>
      </v-flex>
    </v-layout>
  </v-card>
  <v-card v-if="!showPortfolio">
    <v-container
      fluid
      grid-list-md
    >
      <v-layout row wrap>
        <!-- <v-flex xs3>
          <v-select
            v-model="school_filter"
            :items="schools"
            :label="$t('extracurriculares.register.schools')"
            @change="filter_courses"
            clearable
          ></v-select>
        </v-flex> -->
        <v-flex xs3>
          <v-select
            v-model="type_filter"
            :items="types"
            :label="$t('extracurriculares.register.course_types')"
            @change="filter_courses"
            clearable
          ></v-select>
        </v-flex>
        <v-flex xs3>
          <v-text-field
            v-model="search_filter"
            :label="$t('extracurriculares.register.search')"
            @keydown="filter_courses"
            clearable
          ></v-text-field>
        </v-flex>
        <!-- <v-flex xs3>
          <v-select
            v-model="grade_filter"
            :items="grades"
            :label="$t('extracurriculares.register.grades')"
            @change="filter_courses"
            clearable
          ></v-select>
        </v-flex> -->
      </v-layout>
    </v-container>
    <v-container
      fluid
      grid-list-md
    >
      <v-layout row wrap>
        <v-flex
          v-for="course in courses_to_show"
          :key="course.id"
          xs3
        >
          <v-card
           height="100%"
          >
            <v-img
              :src="getFirstCourseFile(course.id)"
              height="150px"
            >
            </v-img>
            <v-card-title>
              <div>
                <span class="grey--text">{{ course.course_type.name }}</span><br>
                <span v-if="locale == 'es'">{{ course.name }}</span>
                <span v-else >{{ course.eng_name }}</span><br>
                <span v-if="course.exclusion_type === 'grade'" ><b>{{ $t('extracurriculares.courses.form.grades') }}: {{ course.grades }}</b></span>
                <span v-if="course.exclusion_type === 'next_grade'" ><b>{{ $t('extracurriculares.courses.form.next_grade') }}: {{ course.grades }}</b></span>
                <span v-if="course.exclusion_type === 'age'" >{{ $t('extracurriculares.courses.form.ages') }}: {{ course.ages }}</span><br>
                <span :style="{textDecoration : course.finalprice > course.discountprice ? 'line-through' : 'none'}">{{ $t('extracurriculares.courses.form.price') }}: ${{ formatNumber(course.finalprice) }}</span><br>
                <span v-if="course.finalprice > course.discountprice">{{ $t('extracurriculares.courses.form.price') }}: ${{ formatNumber(course.discountprice) }}</span><br>
                <span v-if="course.periodicity">{{$t('extracurriculares.courses.form.periodicity')}}: {{ $t(`extracurriculares.courses.form.periodicity_options['${course.periodicity}']`) }}</span><br><br>
                <span
                  class="warning white--text pa-1"
                  mt-1
                  v-if="course.provider_payment == 1">
                  {{ $t('extracurriculares.register.available_courses.provider_pay') }}
                </span>
                <span
                  class="primary white--text pa-1"
                  mt-1
                  v-if="course.availablequotas <= 0">
                  {{ $t('extracurriculares.register.available_courses.course_not_added_text') }}
                </span>
              </div>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-title>
              <div>
                <span class="grey--text">{{ $t('extracurriculares.courses.schedule') }}</span><br>
                <div v-for="(schedule, sh) in course.active_schedules" :key="sh">
                  <span>{{ sh + 1 }}.</span>
                  <span v-if="locale == 'es'">{{ schedule.name }}</span>
                  <span v-else>{{ schedule.eng_name }}</span>
                </div>
              </div>
            </v-card-title>
            <v-card-actions>
              <v-card-actions>
                <v-btn
                  :disabled="course.availablequotas <= 0"
                  :loading="loading_button === course.id"
                  flat
                  outline
                  @click="reserve(course.id)"
                  color="primary">
                  {{ $t('extracurriculares.register.available_courses.add') }}</v-btn>
                <v-btn flat outline @click="courseDetails(course.id)" color="secondary">{{ $t('extracurriculares.register.available_courses.details') }}</v-btn>
              </v-card-actions>
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </v-card>
  <v-alert
      v-else
      :value="true"
      type="info"
    >
      {{ $t('extracurriculares.register.available_courses.portfolio') }}
    </v-alert>
  <v-dialog v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
    <v-card>
      <v-toolbar dark color="primary">
        <v-btn icon dark @click="dialog = false">
          <v-icon>close</v-icon>
        </v-btn>
        <v-toolbar-title>{{ $t('extracurriculares.register.available_courses.course_detail_title') }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn
            dark
            flat
            @click="reserve(course_detail.id)"
            :disabled="course_detail.availablequotas <= 0"
          >{{ $t('extracurriculares.register.available_courses.add') }}</v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <v-list three-line subheader>
        <v-subheader>{{ $t('extracurriculares.register.available_courses.course') }}</v-subheader>
        <v-container fluid>
          <v-layout row>
            <v-flex xs3>
              <div class="detail">
            <span class="detail_title">{{ $t('extracurriculares.courses.form.type') }}</span><br>
            <span class="detail_text">{{ course_detail.course_type.name }}</span>
            </div>
            <div class="detail">
              <span class="detail_title">{{ $t('extracurriculares.courses.form.name') }}</span><br>
              <span v-if="locale == 'es'" class="detail_text">{{ course_detail.name }}</span>
              <span v-else class="detail_text">{{ course_detail.eng_name }}</span>
            </div>

            <div v-if="course_detail.ages" class="detail">
              <span class="detail_title">{{ $t('extracurriculares.courses.form.ages') }}</span><br>
              <span class="detail_text">{{ course_detail.ages }}</span>
            </div>
            <div v-if="course_detail.grades" class="detail">
              <span class="detail_title">{{ $t('extracurriculares.courses.form.grades') }}</span><br>
              <span class="detail_text">{{ course_detail.grades }}</span>
            </div>
            <div class="detail">
              <span class="detail_title">{{ $t('extracurriculares.courses.form.price') }}</span><br>
              <span
                :style="{textDecoration : course_detail.finalprice > course_detail.discountprice ? 'line-through' : 'none'}"
                class="detail_text">${{ formatNumber(course_detail.price) }}</span><br>
              <span v-if="course_detail.finalprice > course_detail.discountprice" class="detail_text">${{ formatNumber(course_detail.discountprice) }}</span><br>
              <span v-if="course_detail.provider_payment === 1" class="detail_text">
                {{ $t('extracurriculares.register.available_courses.provider_pay') }}
              </span>
            </div>
            </v-flex>
            <v-flex xs5 pr-5>
              <div class="detail">
                <span class="detail_title">{{ $t('extracurriculares.courses.form.description') }}</span><br>
                <span v-if="locale == 'es'" class="detail_text">{{ course_detail.description }}</span>
                <span v-else class="detail_text">{{ course_detail.eng_description }}</span>
              </div>
            </v-flex>
          </v-layout>
        </v-container>
        <div class="course_detail">

        </div>
      </v-list>
      <v-divider></v-divider>
      <v-list three-line subheader>
        <v-subheader>{{ $t('extracurriculares.register.available_courses.aditional_info') }}</v-subheader>
        <v-container fluid>
          <v-layout row >
            <v-flex xs4>
              <v-layout row wrap column>
                <v-flex 12>
                  <span class="extra_info_title">{{ $t('extracurriculares.register.available_courses.schedules') }}</span>
                </v-flex>
                <v-flex 12>
                  <v-layout row wrap>
                    <v-flex xs6 v-for="(schedule, is) in course_detail.active_schedules" :key="is">
                      <div class="schedule_item">
                        <v-subheader v-if="locale == 'es'">{{ schedule.name }}</v-subheader>
                        <v-subheader v-else>{{ schedule.eng_name }}</v-subheader>
                        <div v-for="(detail, id) in schedule.details" :key="id" class="schedule_details">
                          <span class="schedule_day">{{ $t(`extracurriculares.courses.schedules.days.${detail.day.substring(0, 3)}`) }}</span>
                          <span class="schedule_time">{{ detail.time_from }} - {{ detail.time_to }}</span>
                        </div>
                      </div>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
              <v-layout mt-3 row wrap column>
                <v-flex xs12>
                  <span class="extra_info_title">{{ $t('extracurriculares.register.available_courses.clothes') }}</span>
                </v-flex>
                <v-flex xs12>
                  <v-layout row wrap>
                    <v-flex v-for="(clothe, ic) in course_detail.clothes" :key="ic" xs6>
                      <div class="clothe_item">
                        <div>
                          <v-img
                            :src="clothe.clothe.files.length > 0 && clothe.clothe.files[0].file_url"
                            width="100px"
                          ></v-img>
                        </div>
                        <div>
                          <v-subheader class="subheading">
                            <b>{{ clothe.clothe.name }}</b>
                          </v-subheader>
                          <div class="ml-3">
                            {{clothe.clothe.sizes.map(size => size.size.name).join(', ')}}
                          </div>
                        </div>
                      </div>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex xs8>
              <v-layout row wrap column>
                <v-flex xs12>
                  <span class="extra_info_title">{{ $t('extracurriculares.register.available_courses.teachers') }}</span>
                </v-flex>
                <v-flex xs12>
                  <v-layout row wrap>
                    <v-flex xs6 v-for="(teacher, it) in course_detail.teachers" :key="it">
                      <div class="teacher_item">
                        <div>
                          <v-img
                            v-if="teacher.teacher.image_url"
                            :src="teacher.teacher.image_url"
                            width="120px"
                            contain
                          ></v-img>
                        </div>
                        <div>
                          <v-subheader>{{ teacher.teacher.name }}</v-subheader>
                          <div class="teacher_details">
                            <span class="teacher_attr">{{ $t('extracurriculares.register.available_courses.schedules') }}</span>:
                            <span class="teacher_text">{{ getSheduleName(teacher.course_id, teacher.schedule_id) }}</span><br>
                            <span class="teacher_attr">{{$t('extracurriculares.teachers.form.description')}}</span>:
                            <span class="teacher_text">{{ teacher.teacher.description }}</span><br>
                            <span class="teacher_attr">{{$t('extracurriculares.teachers.form.email')}}</span>:
                            <span class="teacher_text">{{ teacher.teacher.email }}</span><br>
                          </div>
                        </div>
                      </div>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-container>
      </v-list>
      <v-divider></v-divider>
      <v-list three-line subheader>
        <v-subheader>{{ $t('extracurriculares.register.available_courses.photos_videos') }}</v-subheader>

          <div class="photos_videos">
            <v-carousel height="300" class="photos">
              <v-carousel-item
                v-for="(file,i) in course_detail.files.filter(photo => photo.file_type === 'photo')"
                :key="i"
                :src="file.file_url"
              ></v-carousel-item>
            </v-carousel>
            <div class="videos">
              <video
                v-for="(file,i) in course_detail.files.filter(video => video.file_type === 'video')"
                :key="i"
                height="200px"
                width="200px"
                controls
              >
                <source :src="file.file_url" >
              </video>
            </div>
          </div>

      </v-list>
    </v-card>
  </v-dialog>
  <v-dialog
    v-model="reserve_modal"
    width="1000px"
    persistent
  >
    <v-card>
      <v-toolbar dark color="primary">
        <v-toolbar-title>{{ course_name_in_reservation }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
        </v-toolbar-items>
      </v-toolbar>
      <v-layout ma-1 v-if="!schedules_available" row justify-center>
        <span class="warning white--text pa-1 subheading">{{ $t('extracurriculares.register.available_courses.course_not_added_text') }}</span>
      </v-layout>
      <v-layout pt-3 row justify-center align-center>
          <v-flex xs12>
            <table width="95%">
              <thead>
                <tr>
                  <!-- <th>
                    {{ $t('extracurriculares.register.available_courses.student') }}
                  </th> -->
                  <th colspan="2">
                    {{ $t('extracurriculares.register.available_courses.available_schedules') }}
                  </th>
                  <th>

                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td width="50%">
                    <v-select
                      :items="course_schedules"
                      label="Horario"
                      v-model="user_schedule"
                      name="schedule_id"
                      v-validate="'required'"
                      @change="validateSchedules()"
                    ></v-select>
                    <has-error :form="reserveForm" :field="`schedule_select`"></has-error>
                  </td>
                  <td>
                    <v-btn
                      :loading="loading_reserve_button"
                      @click="addCourse()"
                      color="primary"
                      :disabled="
                        courseReserved ||
                        loading_reserve_button
                        "
                    >
                      <span v-if="courseReserved">{{ $t('extracurriculares.register.available_courses.added') }}</span>
                      <span v-else>{{ $t('extracurriculares.register.available_courses.add') }}</span>
                    </v-btn>
                  </td>
                  <td>
                    <v-alert
                      :value="shceduleValidations"
                      type="warning"
                      outline
                      class="ml-4"
                    >
                      <li
                        v-if="shceduleValidations"
                      >
                        {{ $t('extracurriculares.register.available_courses.schedule_requirement') }}
                      </li>
                    </v-alert>
                  </td>
                    <!--
                  <td>
                      <div v-if="studentPortfolio(student.siesa_sucursal)">
                      <v-alert
                        :value="true"
                        type="warning"
                        outline
                        class="ml-4"
                      >
                        {{ $t('extracurriculares.register.available_courses.portfolio') }}
                      </v-alert>
                    </div> -->
                    <!-- <div v-else-if="(studentRestrictions[student.id] && !studentRestrictions[student.id].available) || shceduleValidations[students_schedule[student.id]]">
                      <v-alert
                        :value="true"
                        type="warning"
                        outline
                        class="ml-4"
                      >
                        <ul>
                          <li
                            v-if="studentRestrictions[student.id] && studentRestrictions[student.id].grade"
                          >
                            {{ $t('extracurriculares.register.available_courses.grade_requirement') }}
                          </li>

                          <li
                            v-if="studentRestrictions[student.id] && studentRestrictions[student.id].age"
                          >
                            {{ $t('extracurriculares.register.available_courses.age_requirement') }}
                          </li>
                          <li
                            v-if="studentRestrictions[student.id] && studentRestrictions[student.id].prerequisite"
                          >
                            {{ $t('extracurriculares.register.available_courses.course_requirement') }}
                          </li>
                          <li
                            v-if="shceduleValidations[students_schedule[student.id]]"
                          >
                            {{ $t('extracurriculares.register.available_courses.schedule_requirement') }}
                          </li>
                        </ul>
                      </v-alert>
                    </div>
                  </td>
                    -->
                </tr>
              </tbody>
            </table>
          </v-flex>
      </v-layout>
      <v-layout row justify-center align-center>
        <v-btn
          color="primary"
          @click="reserve_modal = false"
        >
          {{ $t('close') }}
        </v-btn>
      </v-layout>
    </v-card>
  </v-dialog>
  <v-dialog
    v-model="terms_dialog"
    max-width="600px"
    transition="dialog-transition"
  >
    <terms
      v-on:closeTerms="terms_dialog = false"
    ></terms>
  </v-dialog>
</div>
</template>
<script>
import axios from 'axios'
import Form from 'vform'
import { mapGetters } from 'vuex'
import terms from './../enrollment/terms'
export default {
  name: 'extracurriculares-external-reserve-view',
  components: {
    'terms': terms,
  },
  data() {
    return {
      terms_dialog: false,
      courses: [],
      courses_to_show: [],
      dialog: false,
      course_detail: {
        course_type: {},
        files: []
      },
      showPortfolio: false,
      reservations: [],
      loading_button: 0,
      loading_reserve_button: false,
      loading_page: true,
      schools: [
        { value: 'k4,k5,1', text: 'Preschool' },
        { value: '2,3,4,5', text: 'Elementary School' },
        { value: '6,7,8', text: 'Middle School' },
        { value: '9,10,11,12', text: 'High School' },
      ],
      types: [],
      school_filter: '',
      type_filter: '',
      search_filter: '',
      grade_filter: '',
      registration_ids: [],
      students: [],
      reserve_modal: false,
      course_in_reservation: null,
      studentRestrictions: {},
      course_name_in_reservation: '',
      course_schedules: [],
      user_schedule: '',
      schedules_available: true,
      reserveForm: new Form({}),
      grades: [],
      shceduleValidations: false,
      portfolio: [],
      user: {}
    }
  },
  created() {
    this.getCourses();
  },
  computed: {
    coursesAvailable() {
      return this.courses.length > 0
    },
    courseReserved() {
      return !this.user ? false : this.user.active_reservations && this.user
        .active_reservations
        .filter(reservation => reservation.course_id == this.course_in_reservation && reservation.schedule_id === this.user_schedule)
        .length > 0
    },
    ...mapGetters({
      locale: 'locale',
      authCheck: 'authCheck'
    })
  },
  watch: {
    reserve_modal(newValue, oldValue) {
      if (!newValue) {
        this.course_in_reservation = null
        this.user_schedule = ''
        this.shceduleValidations = false
      }
    }
  },
  methods: {
    getCourses() {
      axios.get('/api/external/extracurriculares/courses_available')
        .then(resp => {
          if (resp.status === 200) {
            const { data } = resp;

            if (data.available_courses) {
              // this.portfolio = data.portfolio
              this.courses = data.courses;
              this.courses_to_show = data.courses
              this.reservations = resp.data.reservations
              this.registration_ids = resp.data.registration_ids
              this.user = resp.data.user

              if (this.course_in_reservation) {
                this.reserve(this.course_in_reservation)
              }
            }
            this.loading_button = 0;
            this.loading_button_student = 0
            this.loading_page = false
          }
        })
        .catch(error => {
          this.loading_page = false
        })

      axios.get('/api/extracurriculares/course_types')
        .then(resp => {
          if (resp.status == 200) {
            resp.data
            .filter(course_type => course_type.status == 1)
            .forEach(course_type => {
              this.types.push(
                { value: course_type.id, text: course_type.name }
              )
            });
          }
        })

      // axios.get('/api/school_grades')
      //   .then(resp => {
      //     if (resp.status === 200) {
      //       resp.data
      //         .map(grade => this.grades.push({ value: grade.name, text: grade.name }))
      //     }
      //   })


    },
    // studentPortfolio(student_sucursal) {
    //   return this.portfolio.filter(value => value.id_sucursal == student_sucursal).length > 0
    // },
    getFirstCourseFile(id) {
      let files = this.courses
        .filter(course => course.id === id)
        .map(course => course.files)[0]
        .filter(file => file.file_type === 'photo');

      if (files.length === 0) {
        return '';
      }

      return files[0].file_url

    },
    courseDetails(id) {
      this.dialog = true;
      this.course_detail = this.courses.find(course => course.id === id);
    },
    reserve(course_id) {

      if (!this.authCheck) {
        console.log('not_logged')
        this.$store.dispatch('responseMessage', {
          type: 'info',
          text: 'Debes iniciar sesión para realizar esta acción',
          title: 'Información',
          modal: true
        })
        this.$router.push({ name: 'login' })
        return;
      }
      this.reserve_modal = true
      this.course_in_reservation = course_id;
      // this.studentRestrictions = {}
      const course = this.courses.find(course => course.id === course_id);
      this.course_schedules = [];
      // this.students_schedule = {}
      let available_schedule;
      course.active_schedules.forEach(schedule => {
          available_schedule = course.quota <= schedule.quotasregistered
          this.course_schedules.push(
            {
              value: schedule.id,
              text: `${schedule.name} ${ available_schedule ? `(${this.$t('extracurriculares.register.available_courses.no_quota')})` : '' }`,
              disabled: available_schedule
            }
          )
      })

      this.schedules_available = this.course_schedules.length > 0

      this.course_name_in_reservation = course.name;

    },
    addCourse() {
      this.loading_reserve_button = true
      this.dialog = false;
      const course_id = this.course_in_reservation;
      const schedule_id = this.user_schedule
      if (!schedule_id) {
        this.reserveForm.errors.set({
          [`schedule_select`]: "Debe seleccionar un horario"
        })
        this.loading_reserve_button = false
        return
      }
      this.loading_button = course_id;
      const registration_id = this.registration_ids.find(registration => registration.course_id == course_id).registration_id
      axios.post('/api/external/extracurriculares/registration/reserve',
          { course_id, registration_id, schedule_id }
        )
        .then(resp => {
          if (resp.status === 200) {
            if (resp.data.reserved) {
              this.$store.dispatch('responseMessage', {
                  type: 'success',
                  text: this.$t('extracurriculares.register.available_courses.course_added_text', {days: resp.data.days_to_pay, hours: resp.data.days_to_pay * 24 }),
                  modal: true
              })
              this.getCourses();

              this.loading_reserve_button = false
              return;
            }
            this.loading_button = 0;
            this.loading_reserve_button = false
            this.$store.dispatch('responseMessage', {
                type: 'warning',
                text: this.$t('extracurriculares.register.available_courses.course_not_added_text'),
                modal: true
            })
          }
        })
        .catch(error => {
          this.loading_reserve_button = false
          this.loading_button = 0;
        })
    },
    getSheduleName(course_id, schedule_id) {
      const schedule = this.course_detail.schedules.find(schedule =>
        schedule.course_id == course_id && schedule.id == schedule_id
        )
      return schedule ? schedule.name : ''
    },
    formatNumber(number) {
      if(!number || typeof number === 'undefined') {
          return 0;
      } else {
          return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      }
    },
    filter_courses() {
      let courses_to_show = this.courses

      if (this.type_filter && this.type_filter !== '') {
        courses_to_show = courses_to_show.filter(course => course.course_type.id === this.type_filter)
      }

      if (this.search_filter && this.search_filter.trim() !== '') {
        courses_to_show = courses_to_show
          .filter(course => course.name.toUpperCase().indexOf(this.search_filter.toUpperCase()) > -1)
      }

      if (this.school_filter && this.school_filter !== '') {
        let course_grades = [];
        let pass_filter = false
        courses_to_show = courses_to_show.filter(course => {
          pass_filter = false
          course_grades = course.grades && course.grades.split(',').map(f => parseInt(f.trim(), 10))
          this.school_filter.split(',')
            .map(f => parseInt(f.trim(), 10))
            .map(f => {
              if (course_grades && course_grades.includes(f)) {
                pass_filter = true
              }
            })
          return pass_filter
        })
      }

      if (this.grade_filter && this.grade_filter !== '') {
        let course_grades = [];
        let pass_filter = false
        courses_to_show = courses_to_show.filter(course => {
          pass_filter = false
          course_grades = course.grades && course.grades.split(',').map(f => f.trim())
          if (course_grades && course_grades.includes(this.grade_filter)) {
            pass_filter = true
          }
          return pass_filter
        })
      }

      this.courses_to_show = courses_to_show
    },
    validateSchedules() {
      const user_schedule = this.user_schedule
      this.shceduleValidations = false
      // this.students_schedule = {}
      // this.students_schedule[student_id] = student_schedule

      const course_id = this.course_in_reservation;
      const schedule_to_validate_details = this.courses
        .find(course => course.id === course_id)
        .active_schedules
        .find(schedule => schedule.id === user_schedule)
        .details

      this.user
        .active_reservations
        .forEach(reservation => {
          reservation.schedule.details.forEach(reservation_detail => {
            schedule_to_validate_details.filter(schedule_to_validate => schedule_to_validate.day === reservation_detail.day)
              .forEach(validation_detail => {
                if (
                    ((Date.parse(`1990-01-01 ${validation_detail.time_from}:00`) >= Date.parse(`1990-01-01 ${reservation_detail.time_from}:00`) &&
                      Date.parse(`1990-01-01 ${validation_detail.time_from}:00`) <= Date.parse(`1990-01-01 ${reservation_detail.time_to}:00`))
                    ||
                    (Date.parse(`1990-01-01 ${validation_detail.time_to}:00`) >= Date.parse(`1990-01-01 ${reservation_detail.time_from}:00`) &&
                      Date.parse(`1990-01-01 ${validation_detail.time_to}:00`) <= Date.parse(`1990-01-01 ${reservation_detail.time_to}:00`)))
                    ||
                    (Date.parse(`1990-01-01 ${reservation_detail.time_from}:00`) >= Date.parse(`1990-01-01 ${validation_detail.time_from}:00`) &&
                      Date.parse(`1990-01-01 ${reservation_detail.time_from}:00`) <= Date.parse(`1990-01-01 ${validation_detail.time_to}:00`))
                    ||
                    (Date.parse(`1990-01-01 ${reservation_detail.time_to}:00`) >= Date.parse(`1990-01-01 ${validation_detail.time_from}:00`) &&
                      Date.parse(`1990-01-01 ${reservation_detail.time_to}:00`) <= Date.parse(`1990-01-01 ${validation_detail.time_to}:00`))
                  ) {
                    this.shceduleValidations = true
                  }
              })
          })
        });
    },
    showTerms() {
      this.terms_dialog = true
    }
  }
}
</script>
<style>
.course_detail {
  display: flex;
  justify-content: space-around;
  padding: 10px;
}
.detail_title {
  font-weight: 600;
}
.photos_videos {
  display: flex;
  justify-content: space-around;
}
.photos {
  margin: 15px;
  width: 40%;
}
.videos {
  margin: 15px;
  display: flex;
  flex-wrap: wrap;
  width: 60%;
}

.videos video {
  margin: 10px;
}

.extra_info_title {
  font-weight: 600;
  font-size: 15px;
  background-color: #bbdefb;
  width: 50%;
  padding: 5px 25px;
}

.schedule {
  display: flex;
}

.schedule_item {
  border: 1px solid lightgrey;
  margin-right: 10px;
  margin-top: 15px;
  padding: 2px;
  display: flex;
  flex-direction: column;
}

.schedule_details {
  margin-left: 15px;
  display: flex;
  flex-direction: column;
}

.schedule_day {
  font-weight: 500;
}

.schedule_time {
  opacity: 0.8;
}

.teacher_item {
  border: 1px solid lightgrey;
  margin-right: 10px;
  margin-top: 15px;
  padding: 15px;
  display: flex;
  align-items: flex-end;
}

.clothe_item {
  border: 1px solid lightgrey;
  margin-right: 2px;
  margin-top: 5px;
  padding: 5px;
  display: flex;
  align-items: center;
}

.teacher_details {
  margin-left: 15px;
}

.teacher_attr {
  font-weight: 500;
}

.teacher_text {
  opacity: 0.8;
}

.clothes_detail {
  margin-left: 15px;
  margin-top: 10px;
}

table,
tr {
  border: 1px solid lightgray;
  padding: 10px;
  margin-left: 10px;
}



</style>



// WEBPACK FOOTER //
// resources/assets/js/pages/extracurriculares/external_enrollment/reserve.vue